import React from 'react'

//import screenshot1 from './curvit-hero-curriculum-vitae-maker.png';
import screenshot2 from './curvit-features.png';
import polymedia_png from './polymedia-peter-van-der-meer-black.png';


export default class extends React.Component {

  constructor(props) {
    super(props);
    this.state = {plan_active:"3"};

    this.highlightNew = this.highlightNew.bind(this);
  }

  componentDidMount() {
    var elements = document.getElementsByClassName("plan");
    for(var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('mouseenter', this.highlightNew);
    }
  }

  highlightNew(e) {
    this.setState({plan_active:e.target.getAttribute("data-id")});
  }

  render() {
    let per1 = 4, per12 = 28, otp = 60;
    return (
      <div>

        <div className="full header">
          <div className="wrap">
            <h1 style={{letterSpacing:"-1px"}}>Curvit CV Maker</h1>
            <h2 style={{color:"#333", letterSpacing:"-.4px", lineHeight:"1.2"}}><span style={{backgroundClip:"text", backgroundImage:"linear-gradient(to right, #f92f60, #ff9900)", color:"#0000"}}>Highlight your experience</span> <span role="img" aria-label="rocket">🚀</span> for employers or your link-in-bio as a founder</h2>
            <button onClick={() => this.props.openModal("register")} className="btn btn-c btn-fat" style={{marginTop:"3em"}}>Get Beta access</button>
            <small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"75%"}}>Use all features for free with the Beta, you only need an email address to get started. See the Pricing section for the Beta limits.</small>
          </div>
        </div>

        <div className="full" style={{paddingTop:"1px", textAlign:"center"}}>
          <div className="wrap">
            {/*<div className="card"><img src={screenshot1} alt="curvit.polymedia.nl | curvit curriculum vitae maker hero" /></div>*/}
            <a href="#features" className="btn btn-offset btn-fat">Features</a>
            <a href="#pricing" className="btn btn-offset btn-fat">Pricing</a>
            <a href="#polymedia" className="btn btn-offset btn-fat">Who is Polymedia?</a>
            <a href="#faq" className="btn btn-offset btn-fat">FAQ</a>
            <a href="https://curvit.polymedia.nl/@peter" target="_blank" rel="noopener noreferrer" className="btn btn-offset btn-fat">Example CV</a>
          </div>
        </div>

        <div id="features" className="full">
          <div className="wrap">
            <h2 style={{textAlign:"center"}}>Features</h2>
            <div className="col-2 usp">
              <h3>Manage your CV</h3><p>An online Curriculum Vitae is really useful when representing yourself. Curvit CV's are also created for founders in mind, with statuses about your projects and links to them.</p>
              <h3>Add your Work Experience or projects</h3><p>Display your proficiency by adding where you have worked, and add your side projects to highlight your own passions.</p>
              <h3>Highligh specific experiences</h3><p>While applying for jobs, you often want to highlight specific experiences on your CV for the specific job. This can also be used to highlight your favorite side project for your link-in-bio.</p>
            </div>
            <div className="col-2"><img src={screenshot2} alt="curvit.polymedia.nl | curvit curriculum vitae maker features" className="screenshot" /></div>
          </div>
        </div>

        <div id="pricing" className="full">
          <div className="wrap">
            <h2 style={{textAlign:"center"}}>Pricing</h2>
            <h3 style={{textAlign:"center", fontWeight:"normal"}}>The Beta is limited to 2 biographies and highlights per CV, has no profile picture, and all links are "nofollow".</h3>
            <div id="plans">
              <div className="plan-container plan-container2">
                <div className={(this.state.plan_active === "3") ? "plan active" : "plan"} data-id="3">
                  <h1>One-Time</h1>
                  <h4>€ {(otp).toFixed(0).toString().replace(".", ",")}</h4>
                  <small style={{marginBottom:"1.3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right", fontWeight:"normal"}}>price includes 21% VAT.</small>
                  <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"normal", textAlign:"left", margin:"0 2em"}}>
                    <li>Create an unlimited amount of highlights and biographies.</li>
                    <li>Add a profile picture to your Curriculum Vitae.</li>
                    <li>All links in your CV will turn into "follow"-links.</li>
                    <li>Promised lifetime of at least 2 years, starting at your purchase. 2 years of a yearly subscription is a total of € 56.</li>
                  </ul>
                  <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-b btn-fat" style={{margin:"58px 0 2em"}}>Get Beta access</button></div>
                </div>
              </div>
              <div className="plan-container plan-container2">
                <div className={(this.state.plan_active === "1") ? "plan active" : "plan"} data-id="1">
                  <h1><span style={{fontSize:"10px"}}>per</span> 1</h1>
                  <p className="months">month</p>
                  <h4>€ {per1.toString().replace(".", ",")}/mo</h4>
                  <p className="savings">&nbsp;</p>
                  <p className="total">€ {(per1 / 30).toFixed(2).toString().replace(".", ",")}/day</p>
                  <small style={{marginBottom:"1.3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right", fontWeight:"normal"}}>price includes 21% VAT.</small>
                  <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"normal", textAlign:"left", margin:"0 2em"}}>
                    <li>Create an unlimited amount of highlights and biographies.</li>
                    <li>Add a profile picture to your Curriculum Vitae.</li>
                    <li>All links in your CV will turn into "follow"-links.</li>
                  </ul>
                  <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-b btn-fat" style={{margin:"2em 0"}}>Get Beta access</button></div>
                </div>
              </div>
              <div className="plan-container plan-container2">
                <div className={(this.state.plan_active === "2") ? "plan active" : "plan"} data-id="2">
                  <span className="value-label favorite">Recommended</span>
                  <h1><span style={{fontSize:"10px"}}>per</span> 12</h1>
                  <p className="months">months</p>
                  <h4>€ {(per12 / 12).toFixed(2).toString().replace(".", ",")}/mo</h4>
                  <p className="savings">Save {(100 - (per12 / 12 / per1 * 100)).toFixed(0).toString().replace(".", ",")}%</p>
                  <p className="total">€ {(per12 / 365).toFixed(2).toString().replace(".", ",")}/day</p>
                  <small style={{marginBottom:"1.3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right", fontWeight:"normal"}}>price includes 21% VAT.</small>
                  <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"normal", textAlign:"left", margin:"0 2em"}}>
                    <li>Create an unlimited amount of highlights and biographies.</li>
                    <li>Add a profile picture to your Curriculum Vitae.</li>
                    <li>All links in your CV will turn into "follow"-links.</li>
                  </ul>
                  <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-b btn-fat" style={{margin:"2em 0"}}>Get Beta access</button></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="polymedia" className="full big accent">
          <div className="wrap content-block">
              <div className="col-2"><img src={polymedia_png} alt="curvit.polymedia.nl | who is polymedia.nl" className="screenshot" style={{margin:"0"}} /></div>
              <div className="col-2">
                <h1 style={{margin:"1rem 0", textAlign:"center"}}>Who is Polymedia?</h1>
                <p style={{fontSize:"20px", textAlign:"left", marginTop:"0"}}>Polymedia consists of Peter, an experienced developer that has developed and maintained multiple popular Extensions for Twitch, the most known are Twitter Feed+ and Instagram Feed+, two Twitch Extensions that daily hundreds of new streamers install on their profiles.<br/><br/>After over five years of development on multiple Twitch Extensions, I realized that I wanted to focus on SaaS Web Applications that I have complete control over. I have been learning about Software-as-a-Service for years, and as evidenced by my LinkedIn and CV, I have a lot of professional work experience building them.</p>
                <div className="socials"><a href="https://curvit.polymedia.nl/@peter" target="_blank" rel="noopener noreferrer" style={{marginRight:"42px"}}>Curvit CV</a><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer" style={{marginRight:"42px"}}>LinkedIn</a><a href="https://twitter.com/PolymediaNL" target="_blank" rel="noopener noreferrer">Twitter</a></div>
              </div>
          </div>
        </div>

        <div id="faq" className="full">
          <div className="wrap wrap-thin content-block">
            <h2 style={{marginBottom:".7em"}}>Frequently Asked Questions</h2>
            <h3 style={{margin:"1em 0 0"}}>What are the features?</h3>
            <p style={{margin:"0"}}>Curvit is a simple Curriculum Vitae (CV) Manager, allowing you to host an online CV to easily share. The biggest difference is that you can create multiple highlights with multiple biographies, allowing you to customize your CV for different employers or different link-in-bio links. This allows you to highlight for example your most recent or most profitable project as a founder. As a job-seeker, this allows you to create different CV's for different companies, tailoring your resumé to their offer.</p>
            <h3 style={{margin:"1em 0 0"}}>Why shouldn't I just use LinkedIn?</h3>
            <p style={{margin:"0"}}>LinkedIn is cluttered with other features, showing your resumé after two page-lengths of scrolling. Curvit is much simpler and more focused. You also can't highlight work experience like you can with Curvit CV Maker.</p>
            <h3 style={{margin:"1em 0 0"}}>Where are the sections like Education, Skills, and Languages?</h3>
            <p style={{margin:"0"}}>To get this project out of the door, the focus is on Work Experience. If there is enough interest I will definitely add those other sections to make the app more complete.</p>
          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Start.js